import React, { useState, useRef, useEffect } from "react";
import { connect, useSelector } from "react-redux";

import {
  EditOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";
import Create_icon from "../../../assets/images/create_icon.png";
import Edit_icon from "../../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../../assets/images/icons/delete_iconbl.svg";

import userIcon from "../../../assets/images/daimond-bg.png";
import { useTranslation } from "react-i18next";
import StudBuilderService from "../../../services/apps-studbuilder.service";
import { Button, Checkbox, Col, DatePicker, Input, Modal, Pagination, Row, Select, Space, Switch, Table, Tooltip } from "antd";


const { Option } = Select;

export const StudBuilderManageVendors = (props) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState("");
  const [dealerId, setDealerId] = useState();

  const columns = [
    {
      title: <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>,
      ellipsis: true,
      dataIndex: "vendor",
    },
    {
      title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
      ellipsis: true,
      dataIndex: "status",
    },
    {
      title: <Tooltip title={t("Data Rating")}>{t("Data Rating")}</Tooltip>,
      ellipsis: true,
      dataIndex: "dataRating",
    },
    {
      title: <Tooltip title={t("Items")}>{t("Items")}</Tooltip>,
      ellipsis: true,
      dataIndex: "items",
    },
    {
      title: <Tooltip title={t("Updated")}>{t("Updated")}</Tooltip>,
      ellipsis: true,
      dataIndex: "updated",
    },
    {
      title: <Tooltip title={t("Action")}>{t("Action")}</Tooltip>,
      ellipsis: true,
      dataIndex: "action",
    },
  ];

  const data = [
    {
      key: "1",
      vendor: "Overnight Mountings Ring Builder",
      status: "Connected",
      dataRating: (
        <div className="star-ratings">
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star-half-o" aria-hidden="true"></i>
        </div>
      ),
      items: "38101",
      updated: "05/05/2019",
      action: "Connected",
    },
    {
      key: "1",
      vendor: "Overnight Mountings Ring Builder",
      status: "Connected",
      dataRating: (
        <div className="star-ratings">
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star-half-o" aria-hidden="true"></i>
        </div>
      ),
      items: "38101",
      updated: "05/05/2019",
      action: "Request Access",
    },
  ];

  const loginDetails = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (loginDetails) {
      if (loginDetails.loginDetials) {
        if (loginDetails.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetails.loginDetials.responseData.dealerId);
          getBindStudBuilderVendor(
            loginDetails.loginDetials.responseData.dealerId,
            pageNumber,
            pageSize
          );
        }
      }
    }
  }, []);
  const getBindStudBuilderVendor = async (id, pageNo, pageSize) => {
    let inputData = {
      dealerID: id,
      filerType: "00",
      currentPage: pageNo,
      recordOnPage: pageSize,
      sortBy: "",
      tagFilter: 0,
      searchKeyChar: "",
      searchType: "",
    };
    try {
      await StudBuilderService.BindDataStudBuilderVendor(inputData)
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  //   const onShowSizeChange = (current, pageSize) => {
  //     setPageNumber(current);
  //     setPageSize(pageSize);
  //     setTimeout(() => {
  //       getBindStudBuilderVendor(current, pageSize);
  //     }, 1000);
  //   };

  function handlePageNoChange(page, pageSize) {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    if (page !== pageNumber) {
      setPageNumber(page);
      getBindStudBuilderVendor(dealerId, page, pageSize);
    }
  }
  function handlePageSizeChange(current, size) {
    if (size !== pageSize) {
      setPageSize(size);
      getBindStudBuilderVendor(dealerId, current, size);
    }
  }

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0"> {t("Manage Vendors")} </h4>
          </div>
        </div>
        <div className="divForm vendors-section">
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              size: "small",
              total: totalCount,
              pageNo: pageNumber,
              pageSize: pageSize,
              pageSizeOptions: [10, 15, 20, 50, 100],
              responsive: true,
              showSizeChanger: true,
              onChange: handlePageNoChange,
              onShowSizeChange: handlePageSizeChange,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StudBuilderManageVendors;
